import { useState } from 'react';

import { Modal } from '../modal/modal';

import styles from './nav.module.css';
import { Link } from '@inertiajs/react';

export function Nav() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    document.body.classList.add('modal-open');
    setModalOpen(true);
  };

  const closeModal = () => {
    document.body.classList.remove('modal-open');
    setModalOpen(false);
  };

  return (
    <>
      <nav className={styles.root}>
        <div className={styles.wrapper}>
          <div className={styles.left}>
            <h1 className={styles.heading}>
              <Link href="/" prefetch>
                <span className={styles.headingRed}>jp</span>
                schoolguide.com
              </Link>
            </h1>
          </div>
          <div className={styles.middle}>
            <ul className={styles.items}>
              <li className={styles.item}>
                <Link className={styles.link} href="/" prefetch>
                  Schools
                </Link>
              </li>
              <li className={styles.item}>
                <Link className={styles.link} href="/about-us/" prefetch>
                  About
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.right}>
            <button onClick={openModal} className={styles.button}>
              Learn <span>Japanese </span>online
            </button>
          </div>
        </div>
      </nav>
      {modalOpen && <Modal closeModal={closeModal} />}
    </>
  );
}
